import axios from "axios";

export default axios.create({
  baseURL: "https://hectorapi.llmate.ai",
});

export const getRequestHeaders = () => {
  const username = localStorage.getItem("username") || "demo19";
  return { "X-User-ID": username, "X-Client-ID": username };
};
